import React, { useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import {
    Sidebar,
    Navbar
} from "../../components";
import {
    Home,
    ProfilIndividuPage,
    KatalogProgramPage,
    ProfilCorporatePage,
    RiwayatTransaksiPage,
    ProgramTerdaftarPage
} from "..";
import { useLocation } from 'react-router-dom';

const MainApp = () => {

    const location = useLocation();

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);

    if (!localStorage.getItem('access_token')) {
        return <div style={{ overflow: 'hidden' }}>
            <div style={{ display: 'flex' }}>
                <div style={{ marginLeft: '300px', marginTop: '100px' }}>
                    <Redirect to='/login' />
                </div>
            </div>
        </div>
    }


    return (
        <Router>
            <Sidebar />
            <Navbar />
            {/*begin::Root*/}
            <div className="page">
                <div className="page-wrapper">
                    <div className="page-body m-4">
                        <Switch>
                            <Route exact path="/">
                                <Home />
                            </Route>
                            <Route exact path="/profile-individu">
                                <ProfilIndividuPage />
                            </Route>
                            <Route exact path="/profile-corporate">
                                <ProfilCorporatePage />
                            </Route>
                            <Route exact path="/katalog-program">
                                <KatalogProgramPage />
                            </Route>
                            <Route exact path="/riwayat-transaksi">
                                <RiwayatTransaksiPage />
                            </Route>
                            <Route exact path="/program-terdaftar">
                                <ProgramTerdaftarPage />
                            </Route>
                        </Switch>
                    </div>
                </div>
            </div >
            {/*end::Root*/}
        </Router >
    );
};

export default MainApp;
